import Card from '@zenbusiness/zui/Card';
import CardContent from '@zenbusiness/zui/CardContent';
import Link from '@zenbusiness/zui/Link';
import { superstyled } from '@zenbusiness/zui/styles';

export const CardWrapper = superstyled({
  name: 'ZuiCard',
  slot: 'Root',
  tag: Card,
  styles: () => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  }),
});

export const ContentWrapper = superstyled({
  name: 'ZuiContentWrapper',
  slot: 'ContentWrapper',
  tag: CardContent,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    height: '100%',
  }),
});

export const ActionLink = superstyled({
  name: 'ZuiLink',
  slot: 'ActionLink',
  tag: Link,
  styles: () => ({
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  }),
});
